export const THUMBNAIL_SIZE_LIST = 55;

export const PACKAGE_EXT = ['.zip'];
export const IMAGE_EXT = [
  '.gif',
  '.png',
  '.bmp',
  '.jpg',
  '.jpeg',
  '.jfif',
  '.pjpeg',
  '.pjp',
  '.webp',
];
export const VIDEO_EXT = ['.mp4', '.mov', '.wmv', '.avi'];

export enum VIEW_TYPE {
  GRID = 'grid',
  LABEL = 'label',
  LIST = 'list',
}

export enum FILE_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
}

export const ACCEPTED_FILES = [...IMAGE_EXT, ...VIDEO_EXT, ...PACKAGE_EXT].join();
